import type { TranslateResult } from 'vue-i18n';
import { ExternalTransactionKind, ExternalTransactionType } from '../bot/enum/ExternalTransactionType';

export function getTransactionStatusLabel(
  kind: ExternalTransactionKind,
  t: (key: string) => TranslateResult
): TranslateResult | null {
  switch (kind) {
    case ExternalTransactionType.DEPOSITS_PENDING:
      return t('page.issue.transaction.title.deposits_pending');

    case ExternalTransactionType.DEPOSITS_SUCCESSFUL:
      return t('page.issue.transaction.title.deposits_successful');

    case ExternalTransactionType.DEPOSITS_FAILED:
      return t('page.issue.transaction.title.deposits_failed');

    case ExternalTransactionType.WITHDRAWALS_PENDING:
      return t('page.issue.transaction.title.withdrawals_pending');

    case ExternalTransactionType.WITHDRAWALS_SUCCESSFUL:
      return t('page.issue.transaction.title.withdrawals_successful');

    case ExternalTransactionType.WITHDRAWALS_FAILED:
      return t('page.issue.transaction.title.withdrawals_failed');

    case ExternalTransactionType.BETS_UNSETTLED:
      return t('page.issue.transaction.title.bets_unsettled');

    case ExternalTransactionType.BETS_VOIDED:
      return t('page.issue.transaction.title.bets_voided');

    case ExternalTransactionType.BETS_WON:
      return t('page.issue.transaction.title.bets_won');

    case ExternalTransactionType.BETS_LOST:
      return t('page.issue.transaction.title.bets_lost');

    default:
      return null;
  }
}
